export default {
  title: '產品分類',
  addFirstLevel: '新增一級分類',
  addSecondLevel: '新增二級分類',
  categoryName: '分類名稱',
  addModal: '新增一級分類',
  editModal: '編輯分類',
  addSecondModal: '新增二級分類',
  required: '請輸入分類名稱',
};
